import React, { useEffect } from 'react'
import { EditText, EditTextarea } from 'react-edit-text'
import Svg from '../../../../../../../component/common/Svg'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { useDispatch } from 'react-redux'
import Card from "../../../../../../../core/Card"
import style from "../../../../../../style.module.css"
import { deleteAndMergeSection, deleteSection, duplicateSection, saveSectionDesc, saveSectionTitle } from '../../../../../../../store/actions/qnaBuilderAction'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next';

function SectionHeader({ language_code, questionCount, sectionData, sectionIndex, survey_id, nextSection, totalSections }) {

    //States
    const deleteModes = { delete: 'DELETE', deleteAndMerge: "DELETE_AND_MERGE" }
    const [deleteMode, setDeleteMode] = useState(deleteModes.deleteAndMerge)
    const [disableMerge, setDisableMerge] = useState(false)
    const [disableDelete, setDisableDelete] = useState(false)
    const [isLastSection, setIsLastSection] = useState(false)
    const dispatch = useDispatch()
    const { t, i18n } = useTranslation();

    //Yup
    const formSchema = Yup.object().shape({
        sectionTitle: Yup.string().trim().required(t('survey.SectionRequired')),
        // sectionDesc: Yup.string().trim().required('Survey description required')
    })

    //Formik
    const initialValues = {
        sectionTitle: '',
        sectionDesc: '',
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: formSchema,
    })

    const {
        values,
        handleChange,
        touched,
        errors,
        setValues,
        setFieldTouched
    } = formik


    //Functionalities
    const handleSaveTitle = ({ value: name }, { su_section_id }) => {
        if (name) {
            const payload = {
                su_section_name: name,
                su_survey_id: survey_id,
                language_code: language_code,
                su_section_id: su_section_id,
            }
            dispatch(saveSectionTitle(payload))
        }
    }

    const handleSaveDesc = ({ value: desc }, { su_section_id }) => {
        if (desc) {
            const payload = {
                su_section_desc: desc,
                su_survey_id: survey_id,
                language_code: language_code,
                su_section_id: su_section_id,
            }
            dispatch(saveSectionDesc(payload))
        }
    }

    const handleDelete = (sectionId) => {
        if (deleteMode === deleteModes.delete) {
            const payload = {
                section_id: sectionId
            }
            dispatch(deleteSection(payload))
        }
        else if (deleteMode === deleteModes.deleteAndMerge) {
            const payload = {
                section_id: sectionId,
                targeted_section_id: nextSection?.su_section_id
            }
            dispatch(deleteAndMergeSection(payload))
        }
    }

    const handleDuplicate = (sectionId) => {
        const afterDuplicate = () => {
            toast.success('Duplicate section created', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
        const payload = {
            section_id: sectionId
        }
        dispatch(duplicateSection(payload, afterDuplicate))
    }


    //Effects
    useEffect(() => {
        if (sectionData) {
            const sectionName = sectionData?.su_section_name && JSON.parse(sectionData?.su_section_name)[language_code]
            const sectionDes = sectionData?.su_section_desc && JSON.parse(sectionData?.su_section_desc)[language_code]
            setValues({
                sectionTitle: sectionName,
                sectionDesc: sectionDes,
            })
        }
    }, [language_code, sectionData])

    useEffect(() => {
        if (totalSections <= 1) {
            setDisableMerge(true)
            setDisableDelete(true)
            setDeleteMode(null)
        }
    }, [totalSections])


    return (
        <>
            <div className="content-wrapper sectionRow">
                <div className="step-name">
                    {/* Edit Version */}
                    <div className="d-flex align-items-start">
                        <div className="flex-grow-1 pe-2">
                            <div className="qna-section-top mb-0">
                                <div className="mb-2 position-relative">
                                    <EditText
                                        className="section-title"
                                        inputClassName='section-title'
                                        placeholder={t('survey.sectionTitle')}
                                        name='sectionTitle'
                                        value={values.sectionTitle}
                                        onChange={handleChange}
                                        onBlur={() => setFieldTouched('sectionTitle', true)}
                                        onSave={(data) => handleSaveTitle(data, sectionData)}
                                        readonly={window.modulePermissions.M11.edit != 1}
                                    />
                                    {touched.sectionTitle && errors.sectionTitle && <div className='validation-msg'>{errors.sectionTitle}</div>}
                                </div>

                                <div className="mb-2">
                                    <EditTextarea
                                        className="section-description"
                                        inputClassName='section-description'
                                        rows={3}
                                        placeholder={t('survey.addDescription')}
                                        name="sectionDesc"
                                        value={values.sectionDesc}
                                        onChange={handleChange}
                                        onBlur={() => setFieldTouched('sectionDesc', true)}
                                        onSave={(data) => handleSaveDesc(data, sectionData)}
                                        readonly={window.modulePermissions.M11.edit != 1}
                                    />
                                    {/* {touched.sectionDesc && errors.sectionDesc && <span>{errors.sectionDesc}</span>} */}
                                </div>
                            </div>
                        </div>
                        <div className="btn-wrap d-flex align-tems-center">
                        {window.modulePermissions.M11.del == 1 && (
                            <button
                                className='btn btn-dlt'
                                type="button"
                                data-bs-toggle="modal"
                                title={t('survey.question.deletes')}
                                onClick={() => {
                                    if (sectionIndex + 1 === totalSections) {
                                            setIsLastSection(true)
                                        }
                                    }
                                }
                                data-bs-target={`#deleteSection${sectionData?.su_section_id}`}>
                                <Svg name="section-delete"
                                />
                            </button>
                        )}
                            {window.modulePermissions.M11.add == 1 && (<button
                                className='btn btn-duplicate'
                                title= {t('survey.question.duplicates')}
                                onClick={() => handleDuplicate(sectionData?.su_section_id)}
                            >
                                <Svg name="duplicate-section" />
                            </button>)}
                            <button
                                className='btn btn-move'
                                type="button"
                                data-bs-toggle="modal"
                                title={t('survey.question.recorders')}
                                data-bs-target="#moveSection">
                                <Svg name="move-section" />
                            </button>
                        </div>
                    </div>
                    <div className="info-text"><i>{`${questionCount} ${questionCount === 0 || questionCount === 1 ? t('survey.question.question') : t('survey.question.questions')}`}</i></div>
                </div>
            </div >
            <div className="customvar-modal modal custom-modal fade deleteModal" id={`deleteSection${sectionData?.su_section_id}`} tabIndex={-1} aria-labelledby="deleteModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className={"formcontainer " + style.container}>
                                <div className={"formvawrapper delete-modal-wrap modal-sm " + style.wrapper}>
                                    <Card view="raised" className={"formstyle p- " + style.card} >
                                        <div className="delete-header d-flex align-items-center">
                                            <div className="icon">
                                                <Svg name="exclamation" />
                                            </div>
                                            <div className="media-body ps-3">
                                                <h4 className='mb-0'>{t('survey.question.del_section1')}</h4>
                                            </div>
                                        </div>
                                        <div className="delete-body-wrap">
                                            <div className="change-field-wrap p-0 mb-5">
                                                <div className="title">{t('survey.question.del_section2')}</div>
                                                <div className="checks-wrap">
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            value={deleteModes.deleteAndMerge}
                                                            name={`deletecheck${sectionData?.su_section_id}`}
                                                            id={`deletecheck1${sectionData?.su_section_id}`}
                                                            checked={deleteMode === deleteModes.deleteAndMerge}
                                                            disabled={disableMerge}
                                                            onChange={(e) => setDeleteMode(e.target.value)}
                                                        />
                                                        <label className="form-check-label" htmlFor={`deletecheck1${sectionData?.su_section_id}`}>
                                                        {t('survey.question.del_section3')} {isLastSection ? t('survey.question.previous'): t('survey.question.next')} {t('survey.question.sections')}
                                                        </label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            value={deleteModes.delete}
                                                            name={`deletecheck${sectionData?.su_section_id}`}
                                                            id={`deletecheck2${sectionData?.su_section_id}`}
                                                            checked={deleteMode === deleteModes.delete}
                                                            disabled={disableMerge}
                                                            onChange={(e) => setDeleteMode(e.target.value)}
                                                        />
                                                        <label className="form-check-label" htmlFor={`deletecheck2${sectionData?.su_section_id}`}>
                                                        {t('survey.question.del_section4')}
                                                        </label>
                                                    </div>
                                                    {disableDelete && disableMerge && <span className='text-primary' >{t('survey.youCanNot')}</span>}
                                                </div>
                                            </div>
                                            <div className="button-wrap d-flex justify-content-center">
                                                <button type="button" className="btn btn-bordered color-cancel" data-bs-dismiss="modal">{t('survey.customVariable.cancel')}</button>
                                                <button type="button" className="btn btn-delete ms-3" data-bs-dismiss="modal" disabled={disableMerge}  onClick={() => handleDelete(sectionData?.su_section_id)}>{t('survey.customVariable.confirm_delete')}</button>
                                            </div>
                                        </div>
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div >
        </>
    )
}

export default SectionHeader